import { Injectable } from '@angular/core';
import { createWarning } from '@core/helpers/create-validator.helper';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { isNilOrEmpty, isNilOrEmptyOrZero } from '@shared/helpers/utils.helper';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';

@Injectable()
export class AltreNotLibriSocWarningService {
    constructor(private store: Store<Revisione53State>) {}

    my_VisualizzaControlloBloccoSemestrale = createWarning(this.store, (myVerbale) => {
        const altreNotizie = myVerbale.my_SezioneI__Rilevazione.my_AltreNotizie;
        if (!isNilOrEmptyOrZero(altreNotizie.my_VisualizzaControlloBloccoSemestrale)) {
            return altreNotizie.my_ctrlBloccoSemestrale || 'Attenzione: risulta decretato il provvedimento di sospensione semestrale.';
        }
        return null;
    });

    my_CkLibriSociali = createWarning(this.store, (myVerbale) => {
        return this._isNotEmptyAndNotOne(
            myVerbale,
            'my_CkLibriSociali',
            "Attenzione: se i Libri sociali non sono stati regolarmente istruiti non sarà possibile rilasciare l'attestato di revisione"
        );
    });

    my_CkLibriSocBolloVid = createWarning(this.store, (myVerbale) => {
        return this._isNotEmptyAndNotOne(
            myVerbale,
            'my_CkLibriSocBolloVid',
            "Attenzione: se i Libri sociali obbligatori non risultano correttamente bollati e vidimati inizialmente non sarà possibile rilasciare l'attestato di revisione"
        );
    });

    my_CkLibroOrgAmm = createWarning(this.store, (myVerbale) => {
        return this._isNotEmptyAndNotOne(
            myVerbale,
            'my_CkLibroOrgAmm',
            "Attenzione: se nel Libro dell'Organo Amministrativo non risultano trascritte le delibere/determinazioni relative ai principali fatti gestionali e quelle relative all'ammissione-recesso-esclusione dei soci non sarà possibile rilasciare l'attestato"
        );
    });

    my_CkLibroOrgContr = createWarning(this.store, (myVerbale) => {
        const my_CkLibroOrgContr = myVerbale.my_SezioneI__Rilevazione.my_AltreNotizie.my_CkLibroOrgContr;
        const my_AllElemCollegioSindacale = myVerbale?.my_SezioneI__Rilevazione?.my_AmministrazioneControllo?.my_AllCollegioSindacale?.my_AllElemCollegioSindacale;

        if (!(isNilOrEmpty(my_CkLibroOrgContr) || my_CkLibroOrgContr === '1') && !(my_AllElemCollegioSindacale?.length <= 0)) {
            return "Attenzione: se nel Libro dell'Organo di Controllo non risultano trascritti i verbali delle riunioni/verifiche da tenersi ogni 90 giorni non sarà possibile rilasciare l'attestato di revisione";
        } else {
            return null;
        }
    });

    my_CkLibroGioInv = createWarning(this.store, (myVerbale) => {
        return this._isNotEmptyAndNotOne(
            myVerbale,
            'my_CkLibroGioInv',
            "Attenzione: se il Libro Giornale ed il Libro Inventari non sono stati regolarmente istituiti non sarà possibile rilasciare l'attestato di revisione"
        );
    });

    my_CkLibroGioInvAgg = createWarning(this.store, (myVerbale) => {
        return this._isNotEmptyAndNotOne(
            myVerbale,
            'my_CkLibroGioInvAgg',
            "Attenzione: se il Libro Giornale ed il Libro Inventari non risultano correttamente numerati ed aggiornati non sarà possibile rilasciare l'attestato di revisione"
        );
    });

    private _isNotEmptyAndNotOne(verbale: MyVerbale, targetPath: string, message: string): string {
        const targetValue: string = verbale.my_SezioneI__Rilevazione.my_AltreNotizie[targetPath];
        if (!(isNilOrEmpty(targetValue) || targetValue === '1')) {
            return message;
        } else {
            return null;
        }
    }
}
